module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"signInButtonText":"Sign In"},"th":{"signInButtonText":"เข้าสู่ระบบ"}}')
  delete Component.options._Ctor
}
